import React from "react";

export function ClubResourcesPage() {
  return (
    <div className="page-container">
      <div className="content">
        <h1>📦 Club Resources</h1>
        <div className="section-cards">
          <div className="section-card">
            <h3>Products</h3>
            <p>View available products and services</p>
          </div>
          <div className="section-card">
            <h3>Inventory</h3>
            <p>Check stock levels and availability</p>
          </div>
          <div className="section-card">
            <h3>Activity</h3>
            <p>Recent transactions and updates</p>
          </div>
        </div>
        <p style={{ color: "#7f8c8d", marginTop: "20px", fontSize: "14px" }}>
          Resources feature coming soon...
        </p>
      </div>
    </div>
  );
}
